/*
 * @Author: 123 1578458020@qq.com
 * @Date: 2023-03-09 15:00:13
 * @LastEditors: 123 1578458020@qq.com
 * @LastEditTime: 2023-03-16 16:42:57
 * @FilePath: \bluesky\bsr-pc\src\routes\find\FLogin.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import { Form, Icon, Input, Button } from 'antd';
import { app } from "../../app"
import "./fregister.css";
// import config from "../../config"
// import api from "../../api"

class FRegister extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                // console.log('Received values of form: ', values);
                if (values.password2 !== values.password) {
                    app.alert("再次输入密码和查询密码不一致！", 'warn');
                    return;
                }
                let data = {
                    mobile: values.phone,
                    idno: values.idcard,
                    vname: values.user,
                    pwd: values.password,
                }
                console.log(data);
                let flag = await this.props.success(data)
                if (flag) {
                    await this.setData({ submit_loading: false, searchplayerList: [], selPpeList: [], head_img: null })
                    this.props.form.resetFields()
                }
            }
        });
    };

    fastLogin = () => {
        this.props.logi();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit} className="login-form">
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12, color: 'red', textAlign: 'center' }}><Icon type="warning" /> 为避免恶意发布虚假信息，发布人必须实名发布寻人启事，发布人信息不对外公示！</div>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label='姓名'
                >
                    {getFieldDecorator('user', {
                        rules: [
                            { required: true, message: '请输入姓名!' },
                            {
                                required: true,
                                validator: (rule, value) => {
                                    let reg = new RegExp(/^[\u00B7\u3007\u3400-\u4DBF\u4E00-\u9FFF\uE000-\uF8FF\uD840-\uD8C0\uDC00-\uDFFF\uF900-\uFAFF]+$/);
                                    if (!reg.test(value)) {
                                        return Promise.reject('请输入正确的姓名');
                                    } else {
                                        return Promise.resolve();
                                    }
                                }
                            },
                        ],

                    })(
                        <Input
                            prefix={<Icon type="user" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="姓名"
                        />,
                    )}
                </Form.Item>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label='身份证号'
                >
                    {getFieldDecorator('idcard', {
                        rules: [
                            { required: true, message: '请输入身份证号!' },
                            {
                                required: true,
                                validator: (rule, value) => {
                                    let reg = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/);
                                    if (!reg.test(value)) {
                                        return Promise.reject('请输入正确的身份证号');
                                    } else {
                                        return Promise.resolve();
                                    }
                                }
                            },
                        ],
                    })(
                        <Input
                            prefix={<Icon type="idcard" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            type="idcard"
                            placeholder="身份证号"
                        />,
                    )}
                </Form.Item>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label='手机号码'
                >
                    {getFieldDecorator('phone', {
                        rules: [{ required: true, message: '请输入手机号码!' },
                        {
                            required: true,
                            validator: (rule, value) => {
                                // let reg = new RegExp(/^[1][3,4,5,6.7,8,9][0-9]{9}$/);
                                if (value.length != 11) {
                                    return Promise.reject('请输入正确的手机号码');
                                } else {
                                    return Promise.resolve();
                                }
                            }
                        },
                        ],
                    })(
                        <Input
                            prefix={<Icon type="phone" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="手机号码"
                        />,
                    )}
                </Form.Item>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label='查询密码'
                >
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: '请输入查询密码!' },
                        {
                            required: true,
                            validator: (rule, value) => {
                                // console.log(value)
                                let reg = new RegExp(/[\u4E00-\u9FA5]/);
                                if (reg.test(value)) {
                                    return Promise.reject('查询密码不能为汉字');
                                } else {
                                    return Promise.resolve();
                                }
                            }
                        },
                        ],
                    })(
                        <Input
                            prefix={<Icon type="lock" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            type="password"
                            placeholder="查询密码"
                        />,
                    )}
                </Form.Item>
                <div className="box1">
                    <p className="animate1">
                        查询密码用于登录寻人大厅，查询/修改已布的寻人启事
                    </p>
                </div>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label='再次输入查询密码'
                >
                    {getFieldDecorator('password2', {
                        rules: [
                            { required: true, message: '请再次输入查询密码!' },
                            // {
                            //     required: true,
                            //     validator: (rule, value) => {
                            //         console.log(getFieldDecorator('password'))
                            //         // if (value !== pasd) {
                            //         //     return Promise.reject('查询密码和再次输入的查询密码不一致');
                            //         // } else {
                            //         //     return Promise.resolve();
                            //         // }
                            //     }
                            // },
                        ],
                    })(
                        <Input
                            prefix={<Icon type="lock" style={{ maxWidth: '300px', color: 'rgba(0,0,0,.25)' }} />}
                            type="password"
                            placeholder="查询密码"
                        />,
                    )}
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop: 24 }}>
                        注册
                    </Button>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '12px' }}>
                        <span style={{ cursor: 'pointer', color: "#1890ff" }} onClick={() => this.fastLogin()}>已有帐号，前往登录</span>
                    </div>
                </Form.Item>
            </Form>
        );
    }
}

export default Form.create()(FRegister);


// WEBPACK FOOTER //
// ./src/routes/find/FRegister.jsx